import acmeInsuranceRenewalBriefMarkdown from '@/assets/Artifacts/acme-insurance-renewal-brief.md?raw'

export const ACME_INSURANCE_RENEWAL_DEMO_ARTIFACT_ID = 'artifact-demo-acme-insurance-renewal-brief'

export const ACME_INSURANCE_RENEWAL_DEMO_ARTIFACT_FILE_NAME = 'Acme Insurance renewal brief.md'

/** @param {{ artifactId?: string, fileName?: string }} selection */
export function isAcmeInsuranceRenewalBriefArtifact(selection) {
  return (
    selection?.artifactId === ACME_INSURANCE_RENEWAL_DEMO_ARTIFACT_ID ||
    selection?.fileName === ACME_INSURANCE_RENEWAL_DEMO_ARTIFACT_FILE_NAME
  )
}

/** @returns {import('@/features/documentPreview/documentPreviewTypes.js').DocPreviewPayload} */
export function buildAcmeInsuranceRenewalDemoArtifactPayload() {
  return {
    markdown: acmeInsuranceRenewalBriefMarkdown,
  }
}

/** @returns {import('@/features/documentPreview/documentPreviewTypes.js').GeneratedArtifactPreview} */
export function buildAcmeInsuranceRenewalDemoArtifactPreview() {
  return {
    artifactId: ACME_INSURANCE_RENEWAL_DEMO_ARTIFACT_ID,
    kind: 'doc',
    fileName: ACME_INSURANCE_RENEWAL_DEMO_ARTIFACT_FILE_NAME,
    description: 'Markdown',
    payload: buildAcmeInsuranceRenewalDemoArtifactPayload(),
  }
}
